// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1Nye_","header":"Messages_header__GUwXl"};